<template>
  <div>
    <!-- <b-row class="mb-3 ml-0">
        <router-link :to="urlToBack">
        <b-button size="sm">{{ $t("geral.back") }}</b-button>
        </router-link>
    </b-row> -->
    <div>
      <h1>Formulário: {{ checklist.formName }}</h1>
    </div>
    <b-row class="mb-3 ml-0">
      <b-button size="sm" @click="backOnSave">{{ $t("geral.back") }}</b-button>
    </b-row>
    <checklist-fill
      ref="teste"
      :checklist="checklist"
      :token="$store.getters.token"
      @finishFilling="backOnSave"
    >
    </checklist-fill>
  </div>
</template>

<script>
import ChecklistFill from "@/mixins/checklist/fill/ChecklistFill";

export default {
  name: "Fill",
  components: {
    ChecklistFill: () =>
      import("@/components_rms/checklist/fill/ChecklistFill.vue")
  },
  mixins: [ChecklistFill],
  props: {
    ChecklistId: String,
    FormId: String
  },
  data: function() {
    return {
      checklist: {
        id: 0,
        formId: 0,
        formName: "",
        draft: false,
        values: [
          {
            fieldId: 0,
            fieldName: "",
            fieldTip: "",
            fieldType: 6,
            allowsAttachment: false,
            required: false,
            value: "",
            options: null
          }
        ]
      }
    };
  },
  mounted: function() {
    if (this.ChecklistId) {
      this.loadDraft();
    } else {
      this.loadData();
    }
  },
  methods: {
    backOnSave() {
      console.log("backOnSave");
      window.history.back();
      //   this.$router.push({
      //     path: urlToBack,
      //   });
    },
    async loadDraft() {
      this.checklist = await this.getChecklistById(
        this.$store.getters.token,
        this.ChecklistId
      );
    },
    async loadData() {
      this.checklist = await this.getChecklistNew(
        this.$store.getters.token,
        this.FormId
      );
    }
  }
};
</script>
